import CountryTable from "../../../views/Country";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const countryRoutes = [
  {
    menuName: MenuNames.COUNTRY,
    path: "/countries",
    component: CountryTable,
    exact: true,
  },
  {
    menuName: MenuNames.COUNTRY,
    path: "/countries/:id(\\d+)",
    component: CountryTable,
    exact: true,
  },
];

export default countryRoutes;
